/** The Content Library open on an asset's preview, inside its folder when it's in one. */
export function assetPreviewPath(assetId: string, folderId?: string | null): string {
  return folderId
    ? `/content-library?folder=${folderId}&preview=${assetId}`
    : `/content-library?preview=${assetId}`;
}

export function assetLinkUrl(assetId: string, folderId?: string | null): string | null {
  if (!assetId) return null;

  return `https://app.${import.meta.env?.VITE_SERVICE_ENVIRONMENT === "-staging" ? "staging." : ""}changeengine.com${assetPreviewPath(assetId, folderId)}`;
}
